import { createApp } from 'vue';
import NavbarMobile from '@layout/nav-v2/mobile/NavbarMobile.vue';
import { piniaNavbarStore } from '@stores/layout/useNavbarStore';

export function initNavbarMobile(): void {
  if (!document.getElementById('navbar-mobile')) {
    return;
  }

  createApp(NavbarMobile)
    .use(piniaNavbarStore)
    .mount('#navbar-mobile');
}
